import { SelectOptionsInterface } from '../interfaces/select-options.interface';
import { SelectMultipleModel } from './select-multiple.model';
import { SelectMultipleValueInterface } from '../interfaces/select-multiple.interface';

export class SelectOptionsModel {
  default?: { // Es el valor por defecto de las opciones ej: 'Elige El numero de asegurados
    label?: string, // Texto del valor por defecto
    selected?: string, // Un string que se buscara en las opciones de lista para seleccionarlo por defecto
    disabled?: boolean // Por defecto es true
  };
  list?: SelectMultipleValueInterface[];
  multiple?: SelectMultipleModel[];

  constructor( obj: SelectOptionsInterface | any = {} ) {
    const ob = obj ? obj : {};

    this.default = ob.default ? ob.default : {};
    this.default.label = this.default && this.default.label ? this.default.label : '';
    this.default.selected = this.default && this.default.selected ? this.default.selected : '';
    this.default.disabled = this.default && this.default.disabled === false ? false : true;
    this.list = ob.list && ob.list.length > 0 ? ob.list : [];
    this.multiple = ob.multiple && ob.multiple.length > 0
      ? ob.multiple.map( ( opt, idx ) => {
        // opt.idx = idx;
        return new SelectMultipleModel( opt );
      } )
      : [];
  }
}
